import React from 'react';
import { StyledActionsButtonLink } from '../StyledComponents';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { postArchiveUnarchiveAccount } from 'modules/mac/duck/actions/accountId';
import { postArchiveUnarchiveLicense } from 'modules/mac/duck/actions/license';

export const ArchiveUnarchiveButtonLink = ({
  isArchiveButtonVisible,
  isArchived,
  accountId,
  isAccount,
}: {
  isArchiveButtonVisible: boolean;
  isArchived: boolean;
  accountId: number;
  isAccount: boolean;
}) => {
  const dispatch = useDispatch();

  const postArchiveUnarchive = isAccount
    ? postArchiveUnarchiveAccount
    : postArchiveUnarchiveLicense;

  const handleArchiveUnarchive = () => {
    dispatch(postArchiveUnarchive(accountId, !isArchived));
  };
  return isArchiveButtonVisible ? (
    <StyledActionsButtonLink
      appearance="link"
      onClick={handleArchiveUnarchive}
      data-cy={`actions-section-${isArchived ? 'unarchive' : 'archive'}-button`}
    >
      <FormattedMessage
        id={`mac.licenses.${isArchived ? 'unarchive' : 'archive'}`}
        defaultMessage={isArchived ? 'Unarchive' : 'Archive'}
      />
    </StyledActionsButtonLink>
  ) : null;
};
